import { yupResolver } from '@hookform/resolvers/yup';
import { DeepPartial, UnpackNestedValue, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { errorsInput } from 'src/consts';
import { isValidPhone } from 'src/helpers';
import * as Yup from 'yup';

type ClientFormHookProps<T> = {
  defaultValues: UnpackNestedValue<DeepPartial<T>>;
  requiredToAgency?: boolean;
  requiredLegal?: boolean;
};

export const useCreateClientFormContainer = <T>({
  defaultValues,
  requiredToAgency,
  requiredLegal,
}: ClientFormHookProps<T>) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required(errorsInput.required),
    lastName: Yup.string().required(errorsInput.required),
    tel: Yup.string()
      .required(errorsInput.required)
      .test('phone-rule', t(errorsInput.phoneInvalid), (value) => {
        return isValidPhone(`+${value}`);
      }),
    email: Yup.string().email(t(errorsInput.emailInvalidFormat)),
    address: Yup.string(),
    ...(requiredToAgency ? { toAgency: Yup.string().required(errorsInput.required) } : null),
    ...(requiredLegal
      ? { requiredLegal: Yup.boolean().required(errorsInput.required).oneOf([true], errorsInput.required) }
      : null),
  });

  const formOptions = { resolver: yupResolver(validationSchema), defaultValues };

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
    watch,
  } = useForm<T>(formOptions);

  return {
    handleSubmit,
    errors,
    reset,
    setValue,
    control,
    watch,
  };
};
